export const TIPOS_ATIVIDADE = [
  { valor: 'ESTAGIO_OBRIGATORIO', rotulo: 'Estágio Obrigatório' },
  { valor: 'ESTAGIO_SUPERVISIONADO', rotulo: 'Estágio Supervisionado' },
  { valor: 'INTERNATO_MEDICO', rotulo: 'Internato Médico' },
  { valor: 'AULA_PRATICA', rotulo: 'Aula Prática' },
];

export const rotuloTipoAtividade = (valor) =>
  TIPOS_ATIVIDADE.find((tipo) => tipo.valor === valor)?.rotulo ?? valor;
